var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.button ? 'button' : 'span',{directives:[{name:"bem",rawName:"v-bem",value:([
        _vm.type,
        _vm.size,
        _vm.invert && ("invert-" + _vm.invert) ]),expression:"[\n        type,\n        size,\n        invert && `invert-${invert}`,\n    ]"}],tag:"component"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }